/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApplicantAppEntityApplicantItemRead } from '../model/applicantAppEntityApplicantItemRead';
// @ts-ignore
import { ApplicantAppEntityApplicantRead } from '../model/applicantAppEntityApplicantRead';
// @ts-ignore
import { ApplicantAppEntityApplicantWrite } from '../model/applicantAppEntityApplicantWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteApplicantApplicantItemRequestParams {
    id: string;
}

export interface GetApplicantCollectionApplicantCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    firstName?: string;
    firstName2?: Array<string>;
    lastName?: string;
    lastName2?: Array<string>;
    name?: string;
    name2?: Array<string>;
    phoneNumber?: string;
    phoneNumber2?: Array<string>;
    phoneNumber3?: string;
    phoneNumber4?: Array<string>;
    email?: string;
    email2?: Array<string>;
    postalCode?: string;
    postalCode2?: Array<string>;
    postOffice?: string;
    postOffice2?: Array<string>;
    city?: string;
    city2?: Array<string>;
    street?: string;
    street2?: Array<string>;
    houseNumber?: string;
    houseNumber2?: Array<string>;
    apartmentNumber?: string;
    apartmentNumber2?: Array<string>;
    country?: string;
    country2?: Array<string>;
    voivodeship?: string;
    voivodeship2?: Array<string>;
    county?: string;
    county2?: Array<string>;
    municipality?: string;
    municipality2?: Array<string>;
    isAnonymized?: boolean;
    isAnonymized2?: Array<boolean>;
    isPseudonimized?: boolean;
    isPseudonimized2?: Array<boolean>;
    anonymizedAt?: string;
    anonymizedAt2?: string;
    pseudonimizedAt?: string;
    pseudonimizedAt2?: string;
    nip?: string;
    nip2?: Array<string>;
    pesel?: string;
    pesel2?: Array<string>;
    identifierType?: string;
    identifierType2?: Array<string>;
    applicantType?: string;
    applicantType2?: Array<string>;
    regon?: string;
    regon2?: Array<string>;
    fatherName?: string;
    fatherName2?: Array<string>;
    motherName?: string;
    motherName2?: Array<string>;
    birthDate?: string;
    birthDate2?: string;
    differentCorrespondenceAddress?: boolean;
    differentCorrespondenceAddress2?: Array<boolean>;
    correspondenceCountry?: string;
    correspondenceCountry2?: Array<string>;
    correspondenceVoivodeship?: string;
    correspondenceVoivodeship2?: Array<string>;
    correspondenceCounty?: string;
    correspondenceCounty2?: Array<string>;
    correspondenceMunicipality?: string;
    correspondenceMunicipality2?: Array<string>;
    correspondenceCity?: string;
    correspondenceCity2?: Array<string>;
    correspondencePostalCode?: string;
    correspondencePostalCode2?: Array<string>;
    correspondencePostOffice?: string;
    correspondencePostOffice2?: Array<string>;
    correspondenceStreet?: string;
    correspondenceStreet2?: Array<string>;
    correspondenceHouseNumber?: string;
    correspondenceHouseNumber2?: Array<string>;
    correspondenceApartmentNumber?: string;
    correspondenceApartmentNumber2?: Array<string>;
    taxpayerStatus?: string;
    taxpayerStatus2?: Array<string>;
    createdAt?: string;
    createdAt2?: string;
    updatedAt?: string;
    updatedAt2?: string;
    deletedAt?: string;
    deletedAt2?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetApplicantItemApplicantItemRequestParams {
    id: string;
}

export interface PatchApplicantApplicantItemRequestParams {
    id: string;
    /** The updated Applicant resource */
    applicant?: ApplicantAppEntityApplicantWrite;
}

export interface PostApplicantApplicantCollectionRequestParams {
    /** The new Applicant resource */
    applicant?: ApplicantAppEntityApplicantWrite;
}


@Injectable({
  providedIn: 'root'
})
export class ApplicantService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Removes the Applicant resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteApplicantApplicantItem(requestParameters?: DeleteApplicantApplicantItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteApplicantApplicantItem(requestParameters?: DeleteApplicantApplicantItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteApplicantApplicantItem(requestParameters?: DeleteApplicantApplicantItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteApplicantApplicantItem(requestParameters?: DeleteApplicantApplicantItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteApplicantApplicantItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/applicants/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the collection of Applicant resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApplicantCollectionApplicantCollection(requestParameters?: GetApplicantCollectionApplicantCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<ApplicantAppEntityApplicantRead>>;
    public getApplicantCollectionApplicantCollection(requestParameters?: GetApplicantCollectionApplicantCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<ApplicantAppEntityApplicantRead>>>;
    public getApplicantCollectionApplicantCollection(requestParameters?: GetApplicantCollectionApplicantCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<ApplicantAppEntityApplicantRead>>>;
    public getApplicantCollectionApplicantCollection(requestParameters?: GetApplicantCollectionApplicantCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const firstName = requestParameters?.firstName;
        const firstName2 = requestParameters?.firstName2;
        const lastName = requestParameters?.lastName;
        const lastName2 = requestParameters?.lastName2;
        const name = requestParameters?.name;
        const name2 = requestParameters?.name2;
        const phoneNumber = requestParameters?.phoneNumber;
        const phoneNumber2 = requestParameters?.phoneNumber2;
        const phoneNumber3 = requestParameters?.phoneNumber3;
        const phoneNumber4 = requestParameters?.phoneNumber4;
        const email = requestParameters?.email;
        const email2 = requestParameters?.email2;
        const postalCode = requestParameters?.postalCode;
        const postalCode2 = requestParameters?.postalCode2;
        const postOffice = requestParameters?.postOffice;
        const postOffice2 = requestParameters?.postOffice2;
        const city = requestParameters?.city;
        const city2 = requestParameters?.city2;
        const street = requestParameters?.street;
        const street2 = requestParameters?.street2;
        const houseNumber = requestParameters?.houseNumber;
        const houseNumber2 = requestParameters?.houseNumber2;
        const apartmentNumber = requestParameters?.apartmentNumber;
        const apartmentNumber2 = requestParameters?.apartmentNumber2;
        const country = requestParameters?.country;
        const country2 = requestParameters?.country2;
        const voivodeship = requestParameters?.voivodeship;
        const voivodeship2 = requestParameters?.voivodeship2;
        const county = requestParameters?.county;
        const county2 = requestParameters?.county2;
        const municipality = requestParameters?.municipality;
        const municipality2 = requestParameters?.municipality2;
        const isAnonymized = requestParameters?.isAnonymized;
        const isAnonymized2 = requestParameters?.isAnonymized2;
        const isPseudonimized = requestParameters?.isPseudonimized;
        const isPseudonimized2 = requestParameters?.isPseudonimized2;
        const anonymizedAt = requestParameters?.anonymizedAt;
        const anonymizedAt2 = requestParameters?.anonymizedAt2;
        const pseudonimizedAt = requestParameters?.pseudonimizedAt;
        const pseudonimizedAt2 = requestParameters?.pseudonimizedAt2;
        const nip = requestParameters?.nip;
        const nip2 = requestParameters?.nip2;
        const pesel = requestParameters?.pesel;
        const pesel2 = requestParameters?.pesel2;
        const identifierType = requestParameters?.identifierType;
        const identifierType2 = requestParameters?.identifierType2;
        const applicantType = requestParameters?.applicantType;
        const applicantType2 = requestParameters?.applicantType2;
        const regon = requestParameters?.regon;
        const regon2 = requestParameters?.regon2;
        const fatherName = requestParameters?.fatherName;
        const fatherName2 = requestParameters?.fatherName2;
        const motherName = requestParameters?.motherName;
        const motherName2 = requestParameters?.motherName2;
        const birthDate = requestParameters?.birthDate;
        const birthDate2 = requestParameters?.birthDate2;
        const differentCorrespondenceAddress = requestParameters?.differentCorrespondenceAddress;
        const differentCorrespondenceAddress2 = requestParameters?.differentCorrespondenceAddress2;
        const correspondenceCountry = requestParameters?.correspondenceCountry;
        const correspondenceCountry2 = requestParameters?.correspondenceCountry2;
        const correspondenceVoivodeship = requestParameters?.correspondenceVoivodeship;
        const correspondenceVoivodeship2 = requestParameters?.correspondenceVoivodeship2;
        const correspondenceCounty = requestParameters?.correspondenceCounty;
        const correspondenceCounty2 = requestParameters?.correspondenceCounty2;
        const correspondenceMunicipality = requestParameters?.correspondenceMunicipality;
        const correspondenceMunicipality2 = requestParameters?.correspondenceMunicipality2;
        const correspondenceCity = requestParameters?.correspondenceCity;
        const correspondenceCity2 = requestParameters?.correspondenceCity2;
        const correspondencePostalCode = requestParameters?.correspondencePostalCode;
        const correspondencePostalCode2 = requestParameters?.correspondencePostalCode2;
        const correspondencePostOffice = requestParameters?.correspondencePostOffice;
        const correspondencePostOffice2 = requestParameters?.correspondencePostOffice2;
        const correspondenceStreet = requestParameters?.correspondenceStreet;
        const correspondenceStreet2 = requestParameters?.correspondenceStreet2;
        const correspondenceHouseNumber = requestParameters?.correspondenceHouseNumber;
        const correspondenceHouseNumber2 = requestParameters?.correspondenceHouseNumber2;
        const correspondenceApartmentNumber = requestParameters?.correspondenceApartmentNumber;
        const correspondenceApartmentNumber2 = requestParameters?.correspondenceApartmentNumber2;
        const taxpayerStatus = requestParameters?.taxpayerStatus;
        const taxpayerStatus2 = requestParameters?.taxpayerStatus2;
        const createdAt = requestParameters?.createdAt;
        const createdAt2 = requestParameters?.createdAt2;
        const updatedAt = requestParameters?.updatedAt;
        const updatedAt2 = requestParameters?.updatedAt2;
        const deletedAt = requestParameters?.deletedAt;
        const deletedAt2 = requestParameters?.deletedAt2;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (firstName !== undefined && firstName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>firstName, 'firstName');
        }
        if (firstName2) {
            firstName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'firstName[]');
            })
        }
        if (lastName !== undefined && lastName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>lastName, 'lastName');
        }
        if (lastName2) {
            lastName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'lastName[]');
            })
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (name2) {
            name2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'name[]');
            })
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>phoneNumber, 'phoneNumber');
        }
        if (phoneNumber2) {
            phoneNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'phoneNumber[]');
            })
        }
        if (phoneNumber3 !== undefined && phoneNumber3 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>phoneNumber3, 'phoneNumber2');
        }
        if (phoneNumber4) {
            phoneNumber4.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'phoneNumber2[]');
            })
        }
        if (email !== undefined && email !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>email, 'email');
        }
        if (email2) {
            email2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'email[]');
            })
        }
        if (postalCode !== undefined && postalCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>postalCode, 'postalCode');
        }
        if (postalCode2) {
            postalCode2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'postalCode[]');
            })
        }
        if (postOffice !== undefined && postOffice !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>postOffice, 'postOffice');
        }
        if (postOffice2) {
            postOffice2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'postOffice[]');
            })
        }
        if (city !== undefined && city !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>city, 'city');
        }
        if (city2) {
            city2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'city[]');
            })
        }
        if (street !== undefined && street !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>street, 'street');
        }
        if (street2) {
            street2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'street[]');
            })
        }
        if (houseNumber !== undefined && houseNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>houseNumber, 'houseNumber');
        }
        if (houseNumber2) {
            houseNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'houseNumber[]');
            })
        }
        if (apartmentNumber !== undefined && apartmentNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>apartmentNumber, 'apartmentNumber');
        }
        if (apartmentNumber2) {
            apartmentNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'apartmentNumber[]');
            })
        }
        if (country !== undefined && country !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>country, 'country');
        }
        if (country2) {
            country2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'country[]');
            })
        }
        if (voivodeship !== undefined && voivodeship !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>voivodeship, 'voivodeship');
        }
        if (voivodeship2) {
            voivodeship2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'voivodeship[]');
            })
        }
        if (county !== undefined && county !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>county, 'county');
        }
        if (county2) {
            county2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'county[]');
            })
        }
        if (municipality !== undefined && municipality !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>municipality, 'municipality');
        }
        if (municipality2) {
            municipality2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'municipality[]');
            })
        }
        if (isAnonymized !== undefined && isAnonymized !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isAnonymized, 'isAnonymized');
        }
        if (isAnonymized2) {
            isAnonymized2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'isAnonymized[]');
            })
        }
        if (isPseudonimized !== undefined && isPseudonimized !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isPseudonimized, 'isPseudonimized');
        }
        if (isPseudonimized2) {
            isPseudonimized2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'isPseudonimized[]');
            })
        }
        if (anonymizedAt !== undefined && anonymizedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>anonymizedAt, 'anonymizedAt');
        }
        if (anonymizedAt2 !== undefined && anonymizedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>anonymizedAt2, 'anonymizedAt[]');
        }
        if (pseudonimizedAt !== undefined && pseudonimizedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pseudonimizedAt, 'pseudonimizedAt');
        }
        if (pseudonimizedAt2 !== undefined && pseudonimizedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pseudonimizedAt2, 'pseudonimizedAt[]');
        }
        if (nip !== undefined && nip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>nip, 'nip');
        }
        if (nip2) {
            nip2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'nip[]');
            })
        }
        if (pesel !== undefined && pesel !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pesel, 'pesel');
        }
        if (pesel2) {
            pesel2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'pesel[]');
            })
        }
        if (identifierType !== undefined && identifierType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>identifierType, 'identifierType');
        }
        if (identifierType2) {
            identifierType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'identifierType[]');
            })
        }
        if (applicantType !== undefined && applicantType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>applicantType, 'applicantType');
        }
        if (applicantType2) {
            applicantType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'applicantType[]');
            })
        }
        if (regon !== undefined && regon !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>regon, 'regon');
        }
        if (regon2) {
            regon2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'regon[]');
            })
        }
        if (fatherName !== undefined && fatherName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>fatherName, 'fatherName');
        }
        if (fatherName2) {
            fatherName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'fatherName[]');
            })
        }
        if (motherName !== undefined && motherName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>motherName, 'motherName');
        }
        if (motherName2) {
            motherName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'motherName[]');
            })
        }
        if (birthDate !== undefined && birthDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>birthDate, 'birthDate');
        }
        if (birthDate2 !== undefined && birthDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>birthDate2, 'birthDate[]');
        }
        if (differentCorrespondenceAddress !== undefined && differentCorrespondenceAddress !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>differentCorrespondenceAddress, 'differentCorrespondenceAddress');
        }
        if (differentCorrespondenceAddress2) {
            differentCorrespondenceAddress2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'differentCorrespondenceAddress[]');
            })
        }
        if (correspondenceCountry !== undefined && correspondenceCountry !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceCountry, 'correspondenceCountry');
        }
        if (correspondenceCountry2) {
            correspondenceCountry2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceCountry[]');
            })
        }
        if (correspondenceVoivodeship !== undefined && correspondenceVoivodeship !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceVoivodeship, 'correspondenceVoivodeship');
        }
        if (correspondenceVoivodeship2) {
            correspondenceVoivodeship2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceVoivodeship[]');
            })
        }
        if (correspondenceCounty !== undefined && correspondenceCounty !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceCounty, 'correspondenceCounty');
        }
        if (correspondenceCounty2) {
            correspondenceCounty2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceCounty[]');
            })
        }
        if (correspondenceMunicipality !== undefined && correspondenceMunicipality !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceMunicipality, 'correspondenceMunicipality');
        }
        if (correspondenceMunicipality2) {
            correspondenceMunicipality2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceMunicipality[]');
            })
        }
        if (correspondenceCity !== undefined && correspondenceCity !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceCity, 'correspondenceCity');
        }
        if (correspondenceCity2) {
            correspondenceCity2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceCity[]');
            })
        }
        if (correspondencePostalCode !== undefined && correspondencePostalCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondencePostalCode, 'correspondencePostalCode');
        }
        if (correspondencePostalCode2) {
            correspondencePostalCode2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondencePostalCode[]');
            })
        }
        if (correspondencePostOffice !== undefined && correspondencePostOffice !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondencePostOffice, 'correspondencePostOffice');
        }
        if (correspondencePostOffice2) {
            correspondencePostOffice2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondencePostOffice[]');
            })
        }
        if (correspondenceStreet !== undefined && correspondenceStreet !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceStreet, 'correspondenceStreet');
        }
        if (correspondenceStreet2) {
            correspondenceStreet2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceStreet[]');
            })
        }
        if (correspondenceHouseNumber !== undefined && correspondenceHouseNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceHouseNumber, 'correspondenceHouseNumber');
        }
        if (correspondenceHouseNumber2) {
            correspondenceHouseNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceHouseNumber[]');
            })
        }
        if (correspondenceApartmentNumber !== undefined && correspondenceApartmentNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>correspondenceApartmentNumber, 'correspondenceApartmentNumber');
        }
        if (correspondenceApartmentNumber2) {
            correspondenceApartmentNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'correspondenceApartmentNumber[]');
            })
        }
        if (taxpayerStatus !== undefined && taxpayerStatus !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxpayerStatus, 'taxpayerStatus');
        }
        if (taxpayerStatus2) {
            taxpayerStatus2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxpayerStatus[]');
            })
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'createdAt');
        }
        if (createdAt2 !== undefined && createdAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt2, 'createdAt[]');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updatedAt');
        }
        if (updatedAt2 !== undefined && updatedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt2, 'updatedAt[]');
        }
        if (deletedAt !== undefined && deletedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt, 'deletedAt');
        }
        if (deletedAt2 !== undefined && deletedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt2, 'deletedAt[]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/applicants`;
        return this.httpClient.request<Array<ApplicantAppEntityApplicantRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a Applicant resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApplicantItemApplicantItem(requestParameters?: GetApplicantItemApplicantItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<ApplicantAppEntityApplicantItemRead>;
    public getApplicantItemApplicantItem(requestParameters?: GetApplicantItemApplicantItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<ApplicantAppEntityApplicantItemRead>>;
    public getApplicantItemApplicantItem(requestParameters?: GetApplicantItemApplicantItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<ApplicantAppEntityApplicantItemRead>>;
    public getApplicantItemApplicantItem(requestParameters?: GetApplicantItemApplicantItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getApplicantItemApplicantItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/applicants/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<ApplicantAppEntityApplicantItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the Applicant resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchApplicantApplicantItem(requestParameters?: PatchApplicantApplicantItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<ApplicantAppEntityApplicantRead>;
    public patchApplicantApplicantItem(requestParameters?: PatchApplicantApplicantItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<ApplicantAppEntityApplicantRead>>;
    public patchApplicantApplicantItem(requestParameters?: PatchApplicantApplicantItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<ApplicantAppEntityApplicantRead>>;
    public patchApplicantApplicantItem(requestParameters?: PatchApplicantApplicantItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchApplicantApplicantItem.');
        }
        const applicant = requestParameters?.applicant;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/applicants/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<ApplicantAppEntityApplicantRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: applicant,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Applicant resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postApplicantApplicantCollection(requestParameters?: PostApplicantApplicantCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<ApplicantAppEntityApplicantRead>;
    public postApplicantApplicantCollection(requestParameters?: PostApplicantApplicantCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<ApplicantAppEntityApplicantRead>>;
    public postApplicantApplicantCollection(requestParameters?: PostApplicantApplicantCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<ApplicantAppEntityApplicantRead>>;
    public postApplicantApplicantCollection(requestParameters?: PostApplicantApplicantCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const applicant = requestParameters?.applicant;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/applicants`;
        return this.httpClient.request<ApplicantAppEntityApplicantRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: applicant,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
